import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
	return localStorage.getItem('companyId')
}

export async function getAllData() {
	const companyId = getCompanyId()
	const { data, error } = await supabase.from('class').select().eq('companyId', companyId).order('class_name', { ascending: true })

	if (error) {
		throw new Error('Failed to fetch data')
	}
	
	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('class').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function addData(adata) {
	const companyId = getCompanyId()
	adata = { ...adata, companyId: companyId }

	const { data, error } = await supabase.from('class').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('class').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('class').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
